export default "__VITE_ASSET__b46be57f__"